import React from 'react';
import FlatButton from "material-ui/FlatButton";
import Dialog from 'material-ui/Dialog';

export default class ConfirmUndoChangesDialog extends React.Component {
    render() {
        const actions = [
            <FlatButton
                label="Cancelar"
                onClick={this.props.handleClose}
            />,
            <FlatButton
                label="Descartar alterações"
                primary={true}
                onClick={this.props.handleConfirm}
            />
        ];

        return (
            <Dialog
                title="Suas informações serão perdidas!"
                actions={actions}
                modal={false}
                open={this.props.open}
                onRequestClose={this.props.handleClose}
                >
                <p>As alterações realizadas no cadastro serão perdidas.</p>
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/view/scheduler/job/ConfirmUndoChangesDialog.js